if (!customElements.get('custom-logo-fields')) {
  customElements.define(
    'custom-logo-fields',
    class CustomLogoFields extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.fieldset = this.querySelector('fieldset');
        this.variantInput = this.form.querySelector('[name="id"]');
        this.delivery = this.querySelector('[data-logo-delivery]');
        this.upload = this.querySelector('[data-logo-upload]');
        this.fileInput = this.querySelector('[type="file"]');
        this.statusInput = this.querySelector('[data-logo-status]');
        this.customVariants = new Set(JSON.parse(this.querySelector('[data-custom-variants]').textContent));
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.variantInput.addEventListener('change', () => this.updateFields(), options);
        this.delivery.addEventListener('change', () => this.updateFields(), options);
        this.fileInput.addEventListener('change', () => this.updateFields(), options);
        this.form.addEventListener('formdata', (event) => this.updateFormData(event.formData), options);
        this.form.addEventListener('submit', (event) => this.validateSubmission(event), {
          ...options,
          capture: true,
        });
        this.updateFields();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      get isCustom() {
        return this.customVariants.has(this.variantInput.value);
      }

      get hasUpload() {
        return this.isCustom && this.delivery.value === 'upload' && this.fileInput.files.length > 0;
      }

      updateFields() {
        this.fieldset.hidden = !this.isCustom;
        this.fieldset.disabled = !this.isCustom;
        this.upload.hidden = this.delivery.value !== 'upload';
        this.fileInput.disabled = !this.isCustom || this.upload.hidden;
        this.statusInput.value = this.hasUpload ? this.dataset.uploadStatus : this.dataset.emailStatus;
        this.fileInput.setCustomValidity('');

        if (!this.hasUpload) return;
        const file = this.fileInput.files[0];
        if (!/\.(png|jpe?g|svg|pdf)$/i.test(file.name)) {
          this.fileInput.setCustomValidity(this.dataset.typeError);
        } else if (file.size > 10 * 1024 * 1024) {
          this.fileInput.setCustomValidity(this.dataset.sizeError);
        }
      }

      updateFormData(formData) {
        if (!this.hasUpload) formData.delete('properties[Logo file]');
        if (this.isCustom) {
          formData.set('properties[Logo artwork]', this.statusInput.value);
        } else {
          formData.delete('properties[Logo artwork]');
          formData.delete('properties[Logo notes]');
        }
      }

      validateSubmission(event) {
        this.updateFields();
        if (!this.hasUpload || this.fileInput.checkValidity()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.fileInput.reportValidity();
      }
    }
  );
}
